import { Box } from 'components/Box';
import { CallToActionButton } from 'components/Button';
import { Flex } from 'components/Flex';
import { Hero } from 'components/Hero';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiGradCtaHeroBlockData } from 'modules/cms/api/types/blocks/CmsApiGradCtaHeroBlock';
import { useCurrentUserHasGradProgram, useIsLoggedIn } from 'modules/cms/hooks';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  data: CmsApiGradCtaHeroBlockData;
  isPageHeader?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsGradCtaHeroBlock({
  data: { text, image, withOverlay },
  isPageHeader,
  blockIndex,
  pageUpdated,
}: Props) {
  const loggedIn = useIsLoggedIn();
  const hasGradProgram = useCurrentUserHasGradProgram();

  return (
    <Hero
      withOverlay={withOverlay}
      heroImage={image}
      data-qa-id="grad-call-to-action-hero"
      minHeight="calc(100vh - 300px)"
    >
      <Box
        maxWidth="768px"
        m="0 auto"
        px="20px"
        mt={['48px', '48px', '48px', '80px']}
        mb={['18px', '18px', '18px', '42px']}
      >
        <RichTextHeadline
          color="white"
          textAlignCenter
          tag={isPageHeader ? 'h1' : undefined}
          styleAs={isPageHeader ? 'h2' : undefined}
          $reverseUnderline
        >
          {text}
        </RichTextHeadline>
      </Box>

      <Flex>
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
          data-qa-id="grad-cta-button"
          onClick={() => {
            trackClicked('CMS Block', {
              block_position: blockIndex,
              block_type: 'Grad Call to Action Hero',
              cta_type: 'Button',
              page_updated: pageUpdated,
            });
          }}
        />
      </Flex>
    </Hero>
  );
}
